/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemSettingTypeViewModel } from '../../models/system-setting-type-view-model';

export interface GetSystemSettingTypes$Params {
}

export function GetSystemSettingTypes(http: HttpClient, rootUrl: string, params?: GetSystemSettingTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemSettingTypeViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetSystemSettingTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SystemSettingTypeViewModel>>;
    })
  );
}

GetSystemSettingTypes.PATH = '/api/SystemSettings/GetSystemSettingTypes';
